import { useState } from "react";
import SpotRichiesteAdminView from "@/pages/SpotRichiesteAdminView";
import SpotImpostazioniView from "@/pages/SpotImpostazioniView";

export default function RfRichiestePage() {
  const [tab, setTab] = useState("richieste");
  return (
    <div>
      <div style={{ margin: "8px 20px 0", display: "flex", gap: 2, borderBottom: "2px solid #00695c", flexWrap: "wrap" }}>
        <TabBtn active={tab === "richieste"} onClick={() => setTab("richieste")} testid="rf-tab-richieste" color="#00695c">📋 Richieste SPOT</TabBtn>
        <TabBtn active={tab === "impostazioni"} onClick={() => setTab("impostazioni")} testid="rf-tab-impostazioni" color="#2e7d32">⚙ Impostazioni</TabBtn>
      </div>
      {tab === "richieste" && <SpotRichiesteAdminView />}
      {tab === "impostazioni" && <SpotImpostazioniView />}
    </div>
  );
}

function TabBtn({ active, onClick, children, testid, color = "#00695c" }) {
  return (
    <button data-testid={testid} onClick={onClick}
      style={{ padding: "8px 18px", border: "none", background: active ? color : "white", color: active ? "white" : color,
        fontWeight: 700, fontSize: 12, cursor: "pointer", borderRadius: "4px 4px 0 0", borderTop: "1px solid #ccc", borderLeft: "1px solid #ccc", borderRight: "1px solid #ccc" }}>
      {children}
    </button>
  );
}
